export const intlNumberFormatLocaleMapping = {
	'de-DE': 'de',
	'en-AU': 'en-AU',
	'en-CA': 'en-CA',
	'en-GB': 'en-GB',
	'en-IN': 'en-IN',
	'en-US': 'en',
	'es-ES': 'es',
	'es-419': 'es-419',
	'es-AR': 'es-AR',
	'fr-FR': 'fr',
	'hi-IN': 'hi',
	'id-ID': 'id',
	'it-IT': 'it',
	'ja-JP': 'ja',
	'ko-KR': 'ko',
	'pt-BR': 'pt',
	'ru-RU': 'ru',
	'th-TH': 'th',
	'tr-TR': 'tr',
} as const;
